<template>
  <div class="col backgroundForm">
        
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Administracion de solicitudes de Certificación</h4>       
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Aprobados</span>
            </div>
            <input type="text" class="form-control" placeholder="MENSAJE DE LOS APROBADOS" v-model="mensaje.aprobados" aria-label="Amount (to the nearest dollar)">
            <div class="input-group-append">
                <button class="btn btn-outline-info" @click="mVerListaAprobadosObservados('F')" ><font-awesome-icon icon="list" /> Ver Lista Aprobados</button>
            </div>
            <div class="input-group-append">
                <button class="btn btn-outline-success" @click="mAprobarObservarSolicitudLote('F')" :disabled="aprobados.length ===0"><font-awesome-icon icon="save" /> Registrar</button>
            </div>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Observados</span>
            </div>
            <input type="text" class="form-control" placeholder="MENSAJE DE LOS OBSERVADOS" v-model="mensaje.observados" aria-label="Amount (to the nearest dollar)">
            <div class="input-group-append">
                <button class="btn btn-outline-warning" @click="mVerListaAprobadosObservados('O')"><font-awesome-icon icon="list" /> Ver Lista Observados</button>
            </div>
            <div class="input-group-append">
                <button class="btn btn-outline-danger" @click="mAprobarObservarSolicitudLote('O')" :disabled="observados.length ===0"><font-awesome-icon icon="save" /> Registrar</button>
            </div>
        </div>
        <hr>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-gral" data-toggle="tab" href="#nav-reg-cert" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="plus" /> Listado General</a>

                <a class="nav-item nav-link" id="nav-update-gral" data-toggle="tab" href="#nav-seg-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Busqueda Individual</a>

                <a class="nav-item nav-link" id="nav-update-gral" data-toggle="tab" href="#nav-seg-cert-per" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Busqueda Persona</a>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Asignacion de presupuesto anual -->
            <div class="tab-pane fade show active" id="nav-reg-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Listado de Solicitudes
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                        <label for="t_file">Fecha Inicio</label>
                        <input type="date"  style="text-transform: uppercase;" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="solicitud_certificado.inicio">
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="t_file">Fecha Final</label>
                        <input type="date" name="date_sol" id="date_sol" class="form-control" autocomplete="off" style="text-transform: uppercase;" v-model="solicitud_certificado.final">
                    </div>
                    
                </div>
                

                <button class="btn btn-warning col-12 col-md-2 offset-md-4" @click="mSearchSolicitudes"><font-awesome-icon icon="list" /> Listar Solicitudes</button>
                <button class="btn btn-outline-info col-12 col-md-2" @click="mReportSolicitudes"><font-awesome-icon icon="file-excel" />Reporte Excel</button>
                <br><br>

                <div class="table-responsive" v-if="listado_solicitudes.length>0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Cedula Identidad</th>
                                <th>Nombres</th>
                                <th>Depósito</th>
                                <th>Fecha Depósito</th>
                                <th >Estado</th>
                                <th>Fecha de Registro</th>
                                <th>Codigo Solicitud</th>
                                <th>Opciones</th>
                                <th>DAF</th>
                                <th>Foto</th>
                            </tr>
                            <tr v-for="(lc, index) in listado_solicitudes" :key="lc.codigo_recepcion">
                                <td>{{ index+1 }}</td>
                                <td>{{ lc.carnet }} {{ lc.expedido }}</td>
                                <td>{{ lc.nombres }}</td>
                                <td>{{ lc.n_deposito }}</td>
                                <td>{{ $dateWrite(lc.fecha_deposito) }}</td>
                                <td :class="lc.color">{{ lc.estado }}</td>
                                <td>{{ $dateWrite(lc.fecha_reg) }}</td>
                                <td>{{ lc.codigo_recepcion }}</td>
                                <td v-if="lc.estado_real==='P'">
                                    <button class="btn btn-success" @click="mAprobarObservarSolicitud(lc, 'F')"><font-awesome-icon icon="check" /></button><button class="btn btn-danger" @click="mAprobarObservarSolicitud(lc, 'O')"><font-awesome-icon icon="times-circle" /></button></td>
                                <td v-else :class="lc.color">{{ lc.estado }}</td>
                                <td :class="lc.revisado_daf ==='N' ? 'alert alert-danger':'alert alert-success' "> 
                                    {{ lc.revisado_daf ==='N' ? 'NO':'SI' }}
                                </td>
                                <td><button class="btn btn-warning" @click="mCallPhotos(lc.codigo_recepcion)"><font-awesome-icon icon="images"/></button></td>
                            </tr>
                        </thead>
                    </table>
                </div>
                
            </div>
            
            <!-- reformulacion del poa -->
            <div class="tab-pane fade" id="nav-seg-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>                
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-warning" align="center">
                        Busqueda Tramite Individual
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Codigo de Trámite</label>
                        <input type="text" min="3" max="20" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="codigo_busqueda_admin">
                    </div>
                </div>

                <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mBuscaCertificadoIndividual"> <font-awesome-icon icon="search" /> Buscar</button>
                <br><br>

                <div class="table-responsive" v-if="resultado_busqueda_admin.estado!=='I'">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Cedula Identidad</th>
                                <th>Nombres</th>
                                <th>Depósito</th>
                                <th>Fecha Depósito</th>
                                <th>Fecha Registro</th>
                                <th>Estado</th>
                                <th>Opciones</th>
                                <th>Revisado DAF</th>
                                <th>Foto</th>
                            </tr>
                            <tr>
                                <td>{{ resultado_busqueda_admin.carnet }} {{ resultado_busqueda_admin.expedido }}</td>
                                <td>{{ resultado_busqueda_admin.nombres }}</td>
                                <td>{{ resultado_busqueda_admin.n_deposito }}</td>
                                <td>{{ $dateWrite(resultado_busqueda_admin.fecha_deposito) }}</td>
                                <td>{{ $dateWrite(resultado_busqueda_admin.fecha_reg) }}</td>
                                <td :class="resultado_busqueda_admin.color">{{ resultado_busqueda_admin.estado }}</td>
                                
                                <td v-if="resultado_busqueda_admin.estado_real==='P'">
                                        <button class="btn btn-success" @click="mAprobarObservarSolicitudCodigo(resultado_busqueda_admin, 'F')"><font-awesome-icon icon="check" /></button><button class="btn btn-danger" @click="mAprobarObservarSolicitudCodigo(resultado_busqueda_admin, 'O')"><font-awesome-icon icon="times-circle" /></button>
                                </td>
                                <td v-else :class="resultado_busqueda_admin.color">{{ resultado_busqueda_admin.estado }}</td>
                                


                                <td :class="resultado_busqueda_admin.revisado_daf ==='N' ? 'alert alert-danger':'alert alert-success' "> 
                                    {{ resultado_busqueda_admin.revisado_daf ==='N' ? 'NO':'SI' }}
                                </td>
                                <td><button class="btn btn-warning"><button class="btn btn-warning" @click="mCallPhotos(resultado_busqueda_admin.codigo_recepcion)"><font-awesome-icon icon="images"/></button></button></td>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-seg-cert-per" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>                
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-warning" align="center">
                        Busqueda Tramite Individual
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Nombre Persona</label>
                        <input type="text" min="3" max="20" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="codigo_busqueda_admin_persona">
                    </div>
                </div>

                <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mBuscaCertificadoIndividualPersona"> <font-awesome-icon icon="search" /> Buscar</button>
                <br><br>
                <div class="table-responsive" v-if="resultado_busqueda_admin_persona.length>0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Cedula Identidad</th>
                                <th>Nombres</th>
                                <th>Depósito</th>
                                <th>Código Solicitud</th>
                                <th>Fecha Depósito</th>
                                <th>Fecha Registro</th>
                                <th>Estado</th>
                                <th>Opciones</th>
                                <th>Revisado DAF</th>
                                <th>Foto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="res_bus_per in resultado_busqueda_admin_persona" :key="res_bus_per.codigo_recepcion" >
                                <td>{{ res_bus_per.carnet }} {{ res_bus_per.expedido }}</td>
                                <td>{{ res_bus_per.nombres }}</td>
                                <td>{{ res_bus_per.n_deposito }}</td>
                                <td>{{ res_bus_per.codigo_recepcion }}</td>
                                <td>{{ $dateWrite(res_bus_per.fecha_deposito) }}</td>
                                <td>{{ $dateWrite(res_bus_per.fecha_reg) }}</td>
                                <td :class="res_bus_per.color">{{ res_bus_per.estado }}</td>
                                <td v-if="res_bus_per.estado_real==='P'">
                                    <button class="btn btn-success" @click="mAprobarObservarSolicitudPersona(res_bus_per, 'F')"><font-awesome-icon icon="check" /></button><button class="btn btn-danger" @click="mAprobarObservarSolicitudPersona(res_bus_per, 'O')"><font-awesome-icon icon="times-circle" /></button></td>
                                <td v-else :class="res_bus_per.color">{{ res_bus_per.estado }}</td>
                                <td :class="res_bus_per.revisado_daf ==='N' ? 'alert alert-danger':'alert alert-success' "> 
                                    {{ res_bus_per.revisado_daf ==='N' ? 'NO':'SI' }}
                                </td>
                                <td><button class="btn btn-warning"><button class="btn btn-warning" @click="mCallPhotos(res_bus_per.codigo_recepcion)"><font-awesome-icon icon="images"/></button></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <modal-photos-deposito
            :id-modal-boat-gallery="idModalPhotos"
            :photos="bImages"
            :name-ship="nameBoat"
        ></modal-photos-deposito>

        <div class="modal fade" :id="modalList.id" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg"  role="document">
            <div class="modal-content">
                <div class="modal-header">
                        <h5 class="modal-title">{{modalList.title}} </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                       <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Codigo</th>
                                    <th>Nombres</th>
                                    <th>Carnet</th>
                                    <th>Excluir</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(lm, index) in modalList.list_mostrar">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ lm.codigo_recepcion }}</td>
                                    <td>{{ lm.nombres }}</td>
                                    <td>{{ lm.carnet }}</td>
                                    <td><button class="btn btn-danger" @click="mExcluyeList(lm)">Excluir</button></td>
                                </tr>
                            </tbody>
                       </table>
                                                                       
                    </div>               
                    
                    <div class="modal-footer">
                        
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                        
                    </div>
            </div>                    
        </div>
    </div>

    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

import modalLoading from '../modal/modalLoading';
import modalPhotosDeposito from "./modalPhotosDeposito";
export default {
    data(){
        return {
            solicitud_certificado:{
                inicio:'',
                final:''
            },
            resultado_busqueda_admin:{estado:'I'},
            resultado_busqueda_admin_persona:[],
            codigo_busqueda_admin:'',
            codigo_busqueda_admin_persona:'',
            listado_solicitudes:[],
            idModalPhotos: "modalPhotos",
            bImages: [],
            nameBoat: 'DEPOSITO',
            observacion:null,
            aprobados:[],
            observados:[],
            mensaje:{
                aprobados:'PUEDE PASAR AL RECOJO POR OFICINAS',
                observados:'SU TRÁMITE TIENE OBSERVACIONES PASE POR OFICINAS'
            },
            modalList:{
                id:'modalOA',
                title:'',
                list_mostrar:[],
                tipo:''
            }
        }
    },
    mounted(){
        this.mChargeInit();
    },
    methods:{
        mExcluyeList(elm){
            switch(this.modalList.tipo){
                case 'O':
                    let idxbo=this.observados.findIndex((elbo)=>elbo.codigo_recepcion===elm.codigo_recepcion);
                    this.observados.splice(idxbo, 1);

                    this.modalList.list_mostrar=this.observados;
                break;

                case 'F':
                    let idxba=this.aprobados.findIndex((elba)=>elba.codigo_recepcion===elm.codigo_recepcion);
                    this.aprobados.splice(idxba, 1);
                    this.modalList.list_mostrar=this.aprobados;
                break;
            }
            
            this.mSearchSolicitudes();
            this.mBuscaCertificadoIndividualPersona();
            this.mBuscaCertificadoIndividual();
            // let idxbp=this.listado_solicitudes.findIndex((ellp)=>ellp.codigo_recepcion===elm.codigo_recepcion);
            // this.listado_solicitudes[idxbp].estado='PENDIENTE';
            // this.listado_solicitudes[idxbp].estado_real='P';
            // this.listado_solicitudes[idxbp].color='alert alert-warning';
        },
        mVerListaAprobadosObservados(tipo){
            console.log(`Ver lista de ${tipo}`)
            this.modalList.list_mostrar= tipo==='F' ? this.aprobados:this.observados;
            this.modalList.tipo=tipo;
            this.modalList.title=tipo==='F' ? 'APROBADOS':'OBSERVADOS';
            this.mShowModalSD(this.modalList.id);
        },
        mCallPhotos(b) {
            this.mShowModalSD(this.idModalL);
            this.mGetPhoto(b);

            setTimeout(() => {
                this.mCloseModalSD(this.idModalL);
                this.mShowModalSD(this.idModalPhotos);
            }, 1000);
        },
        async mGetPhoto(id) {
            try {
                this.bImages = [];
                let ext;
                // let photo = await axios.get(
                // `getPhotos/${id}/N`
                // );

                let photo = await axios.get(`getPhotos/${id}?api_token=${Vue.auth.getToken()}`);

                photo.data.forEach(e => {
                switch (e.extention) {
                    case "jpg":
                    ext = "jpeg";
                    break;

                    case "png":
                    ext = "png";
                    break;
                }

                let ap = {
                    id: e.id_photo,
                    path: `data:image/${ext};base64,${e.path}`,
                    image_principal: e.image_principal
                };
                this.bImages.push(ap);
                });

                this.bImage = this.bImages.find(e => {
                return e.image_principal === 1;
                });
                
            } catch (error) {
                console.error(error);
            }
        },
        async mBuscaCertificadoIndividual(){
            this.resultado_busqueda_admin={estado:'I'};
            if(this.codigo_busqueda_admin.length>0){
                let bcr=await axios.get(`getDocumentStatusAdmin/${this.codigo_busqueda_admin}?api_token=${Vue.auth.getToken()}`);
                        console.log(bcr);
                        if(bcr.data.length>0){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                        //    console.log(bcr.data);
                                                 
                        let ida=this.aprobados.findIndex((ela)=>ela.codigo_recepcion===bcr.data[0].codigo_recepcion);
                        let ido=this.observados.findIndex((elo)=>elo.codigo_recepcion===bcr.data[0].codigo_recepcion);

                        let estado_aux=ida>=0 || ido>=0 ? 'L':bcr.data[0].estado;

                        let aux_estado;
                        let aux_color;
                        switch(estado_aux){
                            case 'P':
                                aux_estado='PROCESO';
                                aux_color='alert alert-warning';
                                break;
                            case 'F':
                                aux_estado='FINALIZADO';
                                aux_color='alert alert-success';
                                break;
                            case 'O':
                                aux_estado='OBSERVADO';
                                aux_color='alert alert-danger';
                                break;
                            case 'L':
                                aux_estado='EN LISTA';
                                aux_color='alert alert-info';
                                break;
                        }
                            this.resultado_busqueda_admin.carnet=bcr.data[0].carnet;
                            this.resultado_busqueda_admin.nombres=`${bcr.data[0].nombres} ${bcr.data[0].paterno} ${bcr.data[0].materno}`;
                            this.resultado_busqueda_admin.n_deposito=bcr.data[0].n_deposito;
                            this.resultado_busqueda_admin.fecha_deposito=bcr.data[0].fecha_deposito;
                            this.resultado_busqueda_admin.fecha_reg=bcr.data[0].fecha_reg;
                            this.resultado_busqueda_admin.estado_real=estado_aux;
                            this.resultado_busqueda_admin.estado=aux_estado;
                            this.resultado_busqueda_admin.codigo_recepcion=bcr.data[0].codigo_recepcion;
                            this.resultado_busqueda_admin.color=aux_color;
                            this.resultado_busqueda_admin.revisado_daf=bcr.data[0].revisado_daf;
                            this.resultado_busqueda_admin.pertenece_ffaa=bcr.data[0].pertenece_ffaa;

                            

                        }else{
                            // solo mostramos el mensaje de error
                            toastr.error(`No existen registros`, 'Error');
                        }
                        setTimeout(()=>{
                            this.is_disabled=false;
                        }, 5000)
            }else{
                toastr.warning("Indique el numero de documento a buscar", 'Advertencia');
            }
        },
        async mBuscaCertificadoIndividualPersona(){
            this.resultado_busqueda_admin_persona=[];
            if(this.codigo_busqueda_admin_persona.length>0){
                let bpc=await axios.get(`getDocumentStatusAdminPerson/${this.codigo_busqueda_admin_persona}?api_token=${Vue.auth.getToken()}`);
                        console.log(bpc);
                        if(bpc.data.length>0){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                        //    console.log(bcr.data);
                        
                        bpc.data.forEach(dts_b=>{
                            
                        let ida=this.aprobados.findIndex((ela)=>ela.codigo_recepcion===dts_b.codigo_recepcion);
                        let ido=this.observados.findIndex((elo)=>elo.codigo_recepcion===dts_b.codigo_recepcion);

                        let estado_aux=ida>=0 || ido>=0 ? 'L':dts_b.estado;

                        let aux_estado;
                        let aux_color;
                        switch(estado_aux){
                            case 'P':
                                aux_estado='PROCESO';
                                aux_color='alert alert-warning';
                                break;
                            case 'F':
                                aux_estado='FINALIZADO';
                                aux_color='alert alert-success';
                                break;
                            case 'O':
                                aux_estado='OBSERVADO';
                                aux_color='alert alert-danger';
                                break;
                            case 'L':
                                aux_estado='EN LISTA';
                                aux_color='alert alert-info';
                                break;
                        }

                           let temp_dts={
                               carnet:dts_b.carnet,
                               nombres:`${dts_b.nombres} ${dts_b.paterno} ${dts_b.materno}`,
                               n_deposito:dts_b.n_deposito,
                               fecha_deposito:dts_b.fecha_deposito,
                               estado_real:estado_aux,
                               estado:aux_estado,
                               codigo_recepcion:dts_b.codigo_recepcion,
                               color:aux_color,
                               revisado_daf:dts_b.revisado_daf,
                               pertenece_ffaa:dts_b.pertenece_ffaa,
                               expedido:dts_b.expedido,
                               fecha_reg:dts_b.fecha_reg
                            }
                            this.resultado_busqueda_admin_persona.push(temp_dts);
                            
                        })
                        // console.log(this.resultado_busqueda_admin_persona);                          

                        }else{
                            // solo mostramos el mensaje de error
                            toastr.error(`No existen registros`, 'Error');
                        }
                        setTimeout(()=>{
                            this.is_disabled=false;
                        }, 5000)
            }else{
                toastr.warning("Indique el numero de documento a buscar", 'Advertencia');
            }
        },
        
        mAprobarObservarSolicitudLote(estado){
            // console.log('aprobando la solicitud');
            console.log(estado);
            let title_aux;
            let body_aux;
            
            switch(estado){
                case 'F':
                    title_aux='Finalizacion Solicitud';
                    body_aux=`¿Desea <b>finalizar</b> la emision del certificado de solicitud de certificacion para <b>${this.aprobados.length}</b> documentos, para que los interesados puedan pasar al recojo del mismo, con el mensaje <b>${this.mensaje.aprobados}</b>`;
                    break;
                case 'O':
                    title_aux='Observar la Solicitud';
                    body_aux=`¿Desea <b>observar</b> la emision del certificado de solicitud de certificacion para <b>${this.observados.length}</b> documentos, para que los interesados puedan pasar a regularizar la observacion, con el mensaje <b>${this.mensaje.observados}</b>`;
                    break;
            }
            let message = {
                title: title_aux,
                body: body_aux
                };

            // console.log(`el id de boat es ${e}`);
            this.observacion=null;
            
            let nca=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                })
                    .catch(function() {
                        resolve(false);
                });
                // this.$dialog
                // .prompt(message)
                // .then(dialog => {
                //     // Triggered when proceed button is clicked
                //     // Show an alert with the user's input as the message
                //     this.observacion=dialog.data ? dialog.data : null
                //     // this.$dialog.alert(dialog.data || '[empty]')
                //     resolve(this.observacion);
                // })
                // .catch(() => {
                //     // Triggered when dialog is dismissed by user
                
                //     console.log('peticion rechazada');
                //     toastr.warning('No se ha enviado la peticion', 'Advertencia')
                // });
            })

            nca.then( async (msg) =>{
                if(msg){
                    try {
                        console.log('se envia el registro al servidor')
                        // this.title_m="Registrando";
                        // this.activeModal(this.id_m_progress);
                        this.is_disabled=true;
                        let rsc;
                        let dts_solicitudes;
                        if(estado==='F'){
                            // rsc=await axios.get(`changeSolicitud/${this.aprobados}/${estado}?api_token=${Vue.auth.getToken()}`);
                            dts_solicitudes={
                                estado:estado,
                                lista:this.aprobados,
                                mensaje:this.mensaje.aprobados
                            }
                        }

                        if(estado==='O'){
                            dts_solicitudes={
                                estado:estado,
                                lista:this.observados,
                                mensaje:this.mensaje.observados
                            }
                        }
                        rsc=await axios.post(`changeSolicitudLote?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_solicitudes));
                        
                        // console.log(adp);
                        if(rsc.data[0].status){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(rsc.data[0].respuesta);
                            this.mSearchSolicitudes();
                            this.mBuscaCertificadoIndividual();
                            this.mBuscaCertificadoIndividualPersona();

                            if(estado==='F'){
                            // rsc=await axios.get(`changeSolicitud/${this.aprobados}/${estado}?api_token=${Vue.auth.getToken()}`);
                                this.aprobados=[];
                            }

                            if(estado==='O'){
                                this.observados=[];
                            }
                            
                        }else{                            
                            // solo mostramos el mensaje de error
                            toastr.warning(rsc.data[0].respuesta);
                            // toastr.error(`${rsc.data[0].respuesta}`, 'Error');
                        }
                        setTimeout(()=>{
                            this.is_disabled=false;
                        }, 5000)

                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            // this.inactiveModal(this.id_m_progress);
                            this.is_disabled=false;
                        }, 5000)
                    }
                }else{
                    console.log('Se ha cancelado el registro')
                }            
            })
        },

        mAprobarObservarSolicitud(soli, estado){
            console.log('aprobando o negando la solicitud');
            // aqui buscamos en ambas listas que no se encuentre en ninguna de observados o aprobados
            let ixApro=this.aprobados.findIndex((ela)=>soli.codigo_recepcion===ela.codigo_recepcion);
            let ixObs=this.observados.findIndex((elo)=>soli.codigo_recepcion===elo.codigo_recepcion);

            console.log(this.aprobados.length);
            console.log(this.observados.length);

            if(ixApro===-1 && ixObs===-1){

                switch(estado){
                case 'F':
                    // aqui añadimos al documento a los aprobados
                    this.aprobados.push(soli);
                    break;
                case 'O':
                    // aqui añadimos a la lista de observados
                    this.observados.push(soli);
                    break;
                }
                let idxbp=this.listado_solicitudes.findIndex((ellp)=>ellp.codigo_recepcion===soli.codigo_recepcion);
                this.listado_solicitudes[idxbp].estado='LISTA';
                this.listado_solicitudes[idxbp].estado_real='L';
                this.listado_solicitudes[idxbp].color='alert alert-info';

            }else{
                let aux_encontrado=ixApro>=0 ? 'Aprobados':'Observados';
                toastr.warning(`No se ha adjuntado al codigo ${soli.codigo_recepcion}, de la persona ${soli.nombres} ya que se encuentra en la lista de ${aux_encontrado}`);
            }            
        },
        mAprobarObservarSolicitudPersona(soli, estado){
            console.log('aprobando o negando la solicitud');
            // aqui buscamos en ambas listas que no se encuentre en ninguna de observados o aprobados
            let ixApro=this.aprobados.findIndex((ela)=>soli.codigo_recepcion===ela.codigo_recepcion);
            let ixObs=this.observados.findIndex((elo)=>soli.codigo_recepcion===elo.codigo_recepcion);

            console.log(this.aprobados.length);
            console.log(this.observados.length);

            if(ixApro===-1 && ixObs===-1){

                switch(estado){
                case 'F':
                    // aqui añadimos al documento a los aprobados
                    this.aprobados.push(soli);
                    break;
                case 'O':
                    // aqui añadimos a la lista de observados
                    this.observados.push(soli);
                    break;
                }
                let idxbp=this.resultado_busqueda_admin_persona.findIndex((ellp)=>ellp.codigo_recepcion===soli.codigo_recepcion);
                this.resultado_busqueda_admin_persona[idxbp].estado='LISTA';
                this.resultado_busqueda_admin_persona[idxbp].estado_real='L';
                this.resultado_busqueda_admin_persona[idxbp].color='alert alert-info';

            }else{
                let aux_encontrado=ixApro>=0 ? 'Aprobados':'Observados';
                toastr.warning(`No se ha adjuntado al codigo ${soli.codigo_recepcion}, de la persona ${soli.nombres} ya que se encuentra en la lista de ${aux_encontrado}`);
            }            
        },
        mAprobarObservarSolicitudCodigo(soli, estado){
            console.log('aprobando o negando la solicitud');
            // aqui buscamos en ambas listas que no se encuentre en ninguna de observados o aprobados
            let ixApro=this.aprobados.findIndex((ela)=>soli.codigo_recepcion===ela.codigo_recepcion);
            let ixObs=this.observados.findIndex((elo)=>soli.codigo_recepcion===elo.codigo_recepcion);

            console.log(this.aprobados.length);
            console.log(this.observados.length);

            if(ixApro===-1 && ixObs===-1){

                switch(estado){
                case 'F':
                    // aqui añadimos al documento a los aprobados
                    this.aprobados.push(soli);
                    break;
                case 'O':
                    // aqui añadimos a la lista de observados
                    this.observados.push(soli);
                    break;
                }
                this.resultado_busqueda_admin.estado_real='L';
                this.resultado_busqueda_admin.estado='EN LISTA';
                this.resultado_busqueda_admin.color='alert alert-info';

            }else{
                let aux_encontrado=ixApro>=0 ? 'Aprobados':'Observados';
                toastr.warning(`No se ha adjuntado al codigo ${soli.codigo_recepcion}, de la persona ${soli.nombres} ya que se encuentra en la lista de ${aux_encontrado}`);
            }            
        },
        mAprobarObservarSolicitud_backup(codigo, estado){
            // console.log('aprobando la solicitud');
            let title_aux;
            let body_aux;
            switch(estado){
                case 'F':
                    title_aux='Finalizacion Solicitud';
                    body_aux=`¿Desea finalizar la emision del certificado de solicitud de certificacion <b>${codigo}</b>, para que el interesado pueda pasar al recojo del mismo?`;
                    break;
                case 'O':
                    title_aux='Observar la Solicitud';
                    body_aux=`¿Desea observar la emision del certificado de solicitud de certificacion <b>${codigo}</b>, para que el interesado pueda pasar a regularizar la observacion?`;
                    break;
            }
            let message = {
                title: title_aux,
                body: body_aux
                };

            let options ={
                promptHelp:'Observacion'
            }
            // console.log(`el id de boat es ${e}`);
            this.observacion=null;
            
            let nca=new Promise((resolve, reject)=>{
                this.$dialog
                .prompt(message, options)
                .then(dialog => {
                    // Triggered when proceed button is clicked
                    // Show an alert with the user's input as the message
                    this.observacion=dialog.data ? dialog.data : null
                    // this.$dialog.alert(dialog.data || '[empty]')
                    resolve(this.observacion);
                })
                .catch(() => {
                    // Triggered when dialog is dismissed by user
                
                    console.log('peticion rechazada');
                    toastr.warning('No se ha enviado la peticion', 'Advertencia')
                });
            })

            nca.then( async (code) =>{
                if(code){
                    try {
                        console.log('se envia el registro al servidor')
                        // this.title_m="Registrando";
                        // this.activeModal(this.id_m_progress);
                        this.is_disabled=true;

                        let rsc=await axios.get(`changeSolicitud/${codigo}/${estado}/${code}?api_token=${Vue.auth.getToken()}`);
                        // console.log(adp);
                        if(rsc.data[0].status){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(rsc.data[0].respuesta);
                            this.mSearchSolicitudes();
                            this.mBuscaCertificadoIndividual();
                            
                        }else{                            
                            // solo mostramos el mensaje de error
                            toastr.warning(rsc.data[0].respuesta);
                            // toastr.error(`${rsc.data[0].respuesta}`, 'Error');
                        }
                        setTimeout(()=>{
                            this.is_disabled=false;
                        }, 5000)

                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            // this.inactiveModal(this.id_m_progress);
                            this.is_disabled=false;
                        }, 5000)
                    }
                }
            })
        },
        mChargeInit(){
            let nd=new Date();
            let anio=nd.getFullYear();
            let mes=nd.getMonth()+1;
            mes = mes<10 ? `0${mes}`:mes;
            let dia=nd.getDate();
            dia=dia<10 ? `0${dia}`:dia;
            this.solicitud_certificado.inicio=`${anio}-${mes}-${dia}`;
            this.solicitud_certificado.final=`${anio}-${mes}-${dia}`;
            // console.log(this.solicitud_certificado.fecha_deposito);
        },
        mValidateList(){
            if(this.solicitud_certificado.inicio.length<9){
                toastr.warning('Indique la fecha de Inicio de Busqueda', 'Advertencia');
                return false;

            }
            if(this.solicitud_certificado.final.length<0){
                toastr.warning('Indique la fecha de Final de Busqueda', 'Advertencia');
                return false;
            }
            let aux_date_init=new Date(this.solicitud_certificado.inicio);
            let aux_date_end=new Date(this.solicitud_certificado.final);
            let milisegundos1=aux_date_init.getTime();
            let milisegundos2=aux_date_end.getTime();
            if(milisegundos1>milisegundos2){
                toastr.warning('La fecha Inicial no puede ser mayor a la Final', 'Advertencia');
                return false;
            }
            return true;
        },
        mReportSolicitudes(){
            if(this.mValidateList()){
                this.url_report=btoa('excelSolicitudes/'+this.solicitud_certificado.inicio+'/'+this.solicitud_certificado.final);
                // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
                let route = this.$router.resolve({path: `/report/${this.url_report}`});            
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }
        },
        async mSearchSolicitudes(){
            if(this.mValidateList()){
                this.listado_solicitudes=[];
                console.log('se ha validado los datos');
                let listSol=await axios.post(`ListSolicitudAdmin?api_token=${Vue.auth.getToken()}`, qs.stringify(this.solicitud_certificado))
                console.log(listSol);
                if(listSol.data.length>0){
                    let aux_list=listSol.data;
                    aux_list.forEach((dts)=>{

                        let ida=this.aprobados.findIndex((ela)=>ela.codigo_recepcion===dts.codigo_recepcion);
                        let ido=this.observados.findIndex((elo)=>elo.codigo_recepcion===dts.codigo_recepcion);

                        let estado_aux=ida>=0 || ido>=0 ? 'L':dts.estado;

                        let aux_estado;
                        let aux_color;
                        switch(estado_aux){
                            case 'P':
                                aux_estado='PROCESO';
                                aux_color='alert alert-warning';
                                break;
                            case 'F':
                                aux_estado='FINALIZADO';
                                aux_color='alert alert-success';
                                break;
                            case 'O':
                                aux_estado='OBSERVADO';
                                aux_color='alert alert-danger';
                                break;
                            case 'L':
                                aux_estado='EN LISTA';
                                aux_color='alert alert-info';
                                break;
                        }
                        let aux={
                            carnet:dts.carnet,
                            expedido:dts.expedido,
                            nombres: `${dts.nombres} ${dts.paterno} ${dts.materno}`,
                            n_deposito:dts.n_deposito,
                            fecha_deposito:dts.fecha_deposito,
                            fecha_reg:dts.fecha_reg,
                            codigo_recepcion:dts.codigo_recepcion,
                            estado:aux_estado,
                            estado_real:estado_aux,
                            color:aux_color,
                            revisado_daf:dts.revisado_daf,
                            pertenece_ffaa:dts.pertenece_ffaa
                        }
                        this.listado_solicitudes.push(aux);
                    })
                }else{
                    toastr.warning('No Hay Registros', 'Busqueda');
                }
            }
        },
        mShowModalSD(idM) {
           $("#" + idM).modal("show");
        },
        mCloseModalSD(idM) {
           $("#" + idM).modal("hide");
        }
    },
    components:{
        "modal-loading": modalLoading,
        "modal-photos-deposito": modalPhotosDeposito
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/certificados/certificadosAdmin.vue